module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/spot_08@2x-9ea4c7c0fed73a735aa6656e2129552c.webp";